import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  menu_open() {
    document.querySelector("header.main_head").style="transform: translateX(0px);"
  }

  menu_close() {
    document.querySelector("header.main_head").style="transform: translateX(320px);"
  }
}